import Vue from 'vue/dist/vue.esm.js';

Vue.component('bodytext', {
  data(){
    return {
      isExpanded:false,
      bodyCopy: null,
      bodyChildNodes: null,
      showButton: false
    }
  },
  mounted(){
    this.setupDefault();
  },
  methods: {
    setupDefault(){
      this.bodyChildNodes = this.$refs.text.childNodes;
      let textNodes = []
      this.bodyChildNodes.forEach((el)=>{
        if(el.nodeName == 'P'){
          textNodes.push(el);
          if(textNodes.length > 2){
            if(!this.isExpanded){
              el.classList.add('bodytext__copy--hidden')
            }else{
              el.classList.remove('bodytext__copy--hidden')
            }
          }
        }
      })

      this.showButton = textNodes.length > 2
      this.textNodes = textNodes
    },
    toggleExpand(){
      this.isExpanded = !this.isExpanded;
      this.setupDefault();
    }
  }
});


new Vue({}).$mount('#bodyTextWrapper');
